export default "__VITE_ASSET__dcfd45af__"